export default class Events {
  static ENGINE_BEFORE_INIT: string = "engine.before-init";
  static ENGINE_AFTER_INIT: string = "engine.after-init";

  static ENGINE_READY: string = "engine.ready";

  static STRUCTURE_BEFORE_LOAD: string = "structure.before-load";
  static STRUCTURE_AFTER_LOAD: string = "structure.after-load";

  static XML_BEFORE_INIT: string = "xml.before-init";
  static XML_AFTER_INIT: string = "xml.after-init";

  static VUE_BEFORE_INIT: string = "vue.before-init";
  static VUE_AFTER_INIT: string = "vue.after-init";

  static VUE_BEFORE_MOUNT: string = "vue.before-mount";
  static VUE_AFTER_MOUNT: string = "vue.after-mount";

  static XML_BEFORE_EXPORT: string = "xml.before-export";
  static XML_AFTER_EXPORT: string = "xml.after-export";

  static XML_BEFORE_IMPORT: string = "xml.before-import";
  static XML_AFTER_IMPORT: string = "xml.after-import";

  static BEFORE_EXPORT: string = "before-export";
  static AFTER_EXPORT: string = "after-export";

  static BEFORE_IMPORT:string = "before-import";
  static AFTER_IMPORT:string =  "after-import";

  static VALUE_CHANGE: string = "value-change";
  static VALUE_SELECTED: string = "value-selected";

  static SECTION_OPEN: string = "section-open";
  static SECTION_CLOSE: string = "section-close";

  static TABLE_DETAIL_OPEN: string = "table-detail-open";
  static TABLE_ROW_BEFORE_CHANGE: string = "table-row-before-change";
  static TABLE_ROW_AFTER_CHANGE: string = "table-row-after-change";
  static TABLE_DETAIL_CLOSE: string = "table-detail-close";
  static TABLE_DETAIL_SAVE: string = "table-detail-save";
  static TABLE_ROW_REMOVE: string = "table-row-remove";

  static VALIDATE: string = "validate";

  static SIGN_FORM: string = "sign-form";

  static HIDE: string = "hide";
  static SHOW: string = "show";

  static DISABLE: string = "disable";
  static ENABLE: string = "enable";
}
